import * as React from 'react'
import { Routes, Route } from 'react-router-dom'

import PlatePage from '../pages/PlatePage'
import WorkspacePage from '../pages/WorkspacePage'

const AppRoutes: React.FC = () => (
  <Routes>
    <Route path="/interact/:plate_id" element={<PlatePage />} />
    <Route path="/create/:plate_id" element={<PlatePage />} />
    <Route path="/workspace" element={<WorkspacePage />} />
  </Routes>
)

export default AppRoutes
